/** Display names for selectable packs. Core is always installed and is not an id. */
export const PACK_LABELS: Record<string, string> = {
  irm: "IRM",
  apisec: "API Security",
  lms: "LMS",
};

export function packLabel(id: string): string {
  return PACK_LABELS[id] || id;
}

/** "Give Asha a Mitti for 7 days". An empty name reads "a learner". */
export function mittiGrantLine(name: string, days: number): string {
  const who = name.trim() || "a learner";
  const n = Number.isInteger(days) && days >= 1 && days <= 30 ? days : 7;
  const unit = n === 1 ? "day" : "days";
  return `Give ${who} a Mitti for ${n} ${unit}`;
}

function joinNames(names: string[]): string {
  if (names.length <= 1) return names[0] || "";
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
}

/** "Adding IRM… installs on next start (about 10 min)". */
export function addingPacksLine(names: string[]): string | null {
  const clean = names.map((n) => n.trim()).filter(Boolean);
  if (clean.length === 0) return null;
  return `Adding ${joinNames(clean)}… installs on next start (about 10 min)`;
}

export function packStatusLine(installing: boolean, pendingNames: string[]): string | null {
  if (installing) return "Installing packs…";
  return addingPacksLine(pendingNames);
}
